// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"9956c055","776":"5374c8d3","922":"98d2d4a7"}[chunkId] + ".chunk.js";
};